export const transferredPlan = {
  title: 'FightCamp Transferred Membership',
  id: 'transferredPlan',
  price: 0,
  category: 'subscription',
  description: '',
  img_url: '',
};
